<template>
  <b-row>
    <b-col sm="12" class="px-5 mb-4">
      <b-button
        v-if="isDemoMode"
        variant="primary"
        :disabled="loading"
        @click="onRegisterUnregistered"
      >
        <b-spinner v-if="loading" />
        <span v-else>Register all unregistered members</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'RegisterUnregisteredUsers',
  props: {
    societyId: {
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
    };
  },
  computed: {
    isDemoMode: function () {
      return this.$store.getters.isDemoMode;
    },
  },
  methods: {
    onRegisterUnregistered: async function () {
      this.loading = true;
      try {
        await Api.registerUnregisteredUsers(this.societyId);
        this.$toasted.success('Unregistered user successfully registered', {
          duration: 3000,
        });
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped></style>
